import { useQuery } from "@tanstack/react-query";

import { memberMe } from "@/lib/api/member";
import { useMemberAuthStore, type CurrentMember } from "@/lib/auth/memberStore";

/** Logged-in member profile: cached login payload first, refreshed from /member/me/ (shared cache key). */
export function useCurrentMember(): CurrentMember | null {
  const cached = useMemberAuthStore((s) => s.member);
  const { data } = useQuery({
    queryKey: ["member", "me"],
    queryFn: memberMe,
    initialData: cached ?? undefined,
    staleTime: 60_000,
  });
  return data ?? cached;
}
